export class ItemOutOfStockDto {
  itemId: number;
  isOutOfStock: boolean;
}
